export default __webpack_public_path__ + "static/media/k18.c891169c.jpg";